import { render, staticRenderFns } from "./CsvItemList.vue?vue&type=template&id=8829e4a6"
import script from "./CsvItemList.vue?vue&type=script&lang=js"
export * from "./CsvItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports